import { Component } from '@angular/core';

@Component({
  selector: 'app-maker-admin',
  templateUrl: './maker-admin.component.html',
  styleUrls: ['./maker-admin.component.css']
})
export class MakerAdminComponent  {
}
